import { CategoryListSet } from "@/api/makeCategorys";
import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@common/queryKeys";

// 카테고리 상세내용 불러오기
export const useGetCategoryDetailList = (code, setCateLoading) => {
  return useQuery({
    queryKey: QUERY_KEYS.CUSTOMIZING.CATEGORY.DETAIL(code),
    queryFn: async () => {
      if (!code) return null;
      try {
        const res = await CategoryListSet({ modes: "ItemDetail", code }); // API 호출

        if (res.Code === "0000") {
          return res.Data || []; // 정상 데이터 반환
        } else {
          console.error(res?.message); // 에러 처리
        }
      } catch (error) {
        console.error(error); // 네트워크 에러 등
      } finally {
        setCateLoading(false); // API 호출 후 반드시 로딩 상태 종료
      }
    },
    enabled: !!code,
    staleTime: 1000 * 60 * 5, // 5분 동안 데이터 유지
    retry: 1, // 요청 실패 시 한 번만 재시도
  });
};
